import { z } from 'zod';
import { nameField } from './name.schema';
import { phoneField } from './phone.schema';
import { cpfField } from './cpf.schema';
import { emailField } from './email.schema';

export const quizSchema = z.object({
  name: nameField,
  phone: phoneField,
  cpf: cpfField,
  email: emailField,
  state: z.string().min(1, 'Estado é obrigatório'),
  city: z.string().min(1, 'Campo obrigatório')
});

export type QuizSchema = z.infer<typeof quizSchema>;
